<template>
  <div class="company-info-page">
    <!-- 基本资料 -->
    <a-card title="个人信息" :bordered="false">
      <a-spin :spinning="spinning">
        <div class="base-info">
          <div class="info-line">
            <span class="label">用户名：</span>
            <span>{{ mobile }}</span>
          </div>
          <div class="info-line">
            <span class="label">真实姓名：</span>
            <template v-if="!spinning">
              <span v-if="certName && certNum">{{ certName }}</span>
              <span v-else style="color: red">账号未实名</span>
            </template>
          </div>
          <div class="info-line">
            <span class="label">身份证号：</span>
            <template v-if="!spinning">
              <span v-if="certName && certNum">{{ certNum }}</span>
              <span v-else style="color: red">请先进行实名认证</span>
            </template>
          </div>
        </div>
      </a-spin>
    </a-card>

    <!-- 账号设置 -->
    <a-card title="账号设置" style="margin-top: 24px" :bordered="false">
      <!-- 实名认证 -->

      <div class="setting-item">
        <div class="col-left">
          <template v-if="!spinning">
            <template v-if="certName && certNum"
              ><span class="status-dot blue"></span>
              <span class="left-title">已认证</span>
            </template>
            <template v-else
              ><span class="status-dot gray"></span>
              <span class="left-title">未认证</span>
            </template>
          </template>
          <a-spin v-else />
        </div>

        <div class="col-desc">实名认证</div>

        <div class="col-extra">保障账户安全，确认用户身份</div>

        <div class="col-action">
          <template v-if="!spinning">
            <a-button
              v-if="certName && certNum"
              type="primary"
              disabled
              size="small"
              >认证</a-button
            >
            <a-button
              v-else
              type="primary"
              size="small"
              @click="changeToCertVerify"
              >认证</a-button
            >
          </template>
          <a-spin v-else />
        </div>
      </div>

      <!-- 手机绑定 -->
      <div class="setting-item">
        <div class="col-left">
          <template v-if="!spinning">
            <span class="status-dot blue"></span>
            <span class="left-title">已绑定</span>
          </template>
          <a-spin v-else />
        </div>

        <div class="col-desc">手机绑定</div>

        <div class="col-extra">
          保障账户中重要信息，在设置、修改交易密码、登录密码等都需要手机短信验证
          <template v-if="!spinning">{{ mobile }}</template>
        </div>

        <div class="col-action">
          <a-button type="primary" disabled size="small">更新</a-button>
        </div>
      </div>

      <!-- 登录密码 -->
      <div class="setting-item">
        <div class="col-left">
          <template v-if="!spinning">
            <span class="status-dot blue"></span>
            <span class="left-title">已设置</span>
          </template>
          <a-spin v-else />
        </div>

        <div class="col-desc">登录密码</div>

        <div class="col-extra">
          保障投资者登录操作时使用，上次登录时间：
          <template v-if="!spinning">{{ lastLoginTime }}</template>
        </div>

        <div class="col-action">
          <a-button type="primary" size="small">更新</a-button>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { personalInfo } from "@/api/user/personalCenter/PersonalCenter.js";
export default {
  data() {
    return {
      accountName: undefined,
      mobile: undefined,
      certName: undefined,
      certNum: undefined,
      lastLoginTime: undefined,
      spinning: true,
    };
  },
  mounted() {
    personalInfo()
      .then((res) => {
        if (res && res.code === "200") {
          const result = res.data;
          this.accountName = result.accountName;
          this.mobile = result.mobile;
          this.certName = result.certName;
          this.certNum = result.certNum;
          this.lastLoginTime = result.lastLoginTime;
          this.spinning = !this.spinning;
        } else {
        }
      })
      .catch((err) => {
        console.error("接口调用异常：", err);
      });
  },
  methods: {
    changeToCertVerify() {
      this.$emit("changeToCertVerify");
    },
    getPersonalInfo() {},
  },
};
</script>

<style scoped>
.company-info-page {
  padding: 8px;
}

/* 基本资料 */
.base-info {
  padding: 8px 16px;
  line-height: 32px;
  font-size: 14px;
}

.info-line .label {
  display: inline-block;
  width: 160px;
  font-weight: bold;
  color: #555;
}

/* 设置模块 */
.setting-item {
  display: grid;
  grid-template-columns: 180px 200px 1fr 50px;
  /* 左列、描述、中间值、按钮列 */
  align-items: center;
  padding: 14px 8px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.setting-item:last-child {
  border-bottom: none;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
}

.status-dot.blue {
  background-color: #1890ff;
}

.status-dot.gray {
  background-color: #d9d9d9;
}

/* 左列：图标 + 标题 */
.col-left {
  display: flex;
  align-items: center;
}

.left-title {
  font-weight: 500;
}

/* 描述多行自动换行 */
.col-desc {
  color: #555;
}

/* 右侧附加字段 */
.col-extra {
  color: #888;
  padding-right: 12px;
}

/* 按钮 */
.col-action {
  text-align: right;
}
</style>